import { Link } from "react-router-dom";

import type { Welcome } from "../../../api/types";
import { Card } from "../../../ui";
import { firstName, STEP_WORDS } from "../model/words";
import { GettingStartedNote } from "./GettingStartedNote";

/**
 * "Welcome back": where the engineer stopped and what came back from the SME (subject matter expert). Who is
 * working on what has a card of its own.
 */
export function WelcomeCard({ welcome, displayName, firstVisit = false }: { welcome: Welcome; displayName: string; firstVisit?: boolean }) {
  const stop = welcome.last_stop;
  const back = welcome.back_from_sme;
  const returned = back.sent_back + back.notes + back.rejected;
  const open = stop?.stop_point.open_card_ids.length ?? 0;
  const step = stop?.stop_point.step ? STEP_WORDS[stop.stop_point.step] : null;
  return (
    <Card aria-labelledby="welcome-title" className="nv-welcome">
      <h2 id="welcome-title">{firstVisit ? "Welcome" : "Welcome back"}, {firstName(displayName)}</h2>
      {firstVisit && <GettingStartedNote />}
      <ul className="nv-welcome__lines">
        <li>
          {stop ? (
            <>
              You stopped in a session{stop.item_name ? ` on ${stop.item_name}` : ""}
              {step ? `, at the ${step} step` : ""}.
              {open > 0 && ` ${open === 1 ? "1 card was" : `${open} cards were`} still open.`}
              {stop.stop_point.note && ` Your note: ${stop.stop_point.note}`}{" "}
              <Link to={`/sessions/${encodeURIComponent(stop.session_id)}`}>Continue the session</Link>
            </>
          ) : (
            <>You have no session in progress. Say what you want to do below, or pick an item in the tree.</>
          )}
        </li>
        <li>
          {returned > 0 ? (
            <>
              Back from the <abbr title="subject matter expert">SME</abbr>: {back.sent_back} sent back, {back.notes} {back.notes === 1 ? "note" : "notes"} waiting for your answer, {back.rejected} rejected.{" "}
              <Link to="/back-from-sme">See what came back</Link>
            </>
          ) : (
            <>Nothing has come back from the SME.</>
          )}
        </li>
      </ul>
    </Card>
  );
}
